module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QwECjE5z5ESvQAAAN5JREFUWMNjYBgFQw1ccnH5f8nF5T+1zGMhxWJaeIiJkpCghgMYKbVIb88exgEJAWqFBE4HTNkfokSs4ejq/v//L4NNHFsCxukAu9YPd8kNCUZGxifEOp6JWsGKnBaQ9V9ycfn/8O25AKIdQI7lurt3a+PT/zG8bD1RDiA3QTEyMl4jJYqefbguh+EAci3HFfQk5YKBspwq5QBV6gL00gybb2BqsMmR6nspAc1HgysEqFnkYgspfKE34CHAREqKp7TmoygKKIkqfNE3/BLhoCmIiE0zQycXDFsHjIJRAAA8inXgwfHzAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/no_activas_bi_con.png
// module id = Dyhw
// module chunks = 0